import { useState } from "react";
import { ArrowLeft, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { ARTICLES } from "@/data/journal";

export default function JournalPage() {
  const [open, setOpen] = useState(null);
  const article = ARTICLES.find((a) => a.id === open);

  return (
    <main data-testid="journal-page" className="bg-[#EFE8DC] text-[#2C241E] pt-24 min-h-screen">
      <section className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-24">
        {!article ? (
          <>
            <Reveal>
              <p className="text-xs font-medium tracking-[0.25em] uppercase text-[#2C241E]/50 mb-4">
                Journal
              </p>
              <h1
                data-testid="journal-page-headline"
                className="font-display text-4xl sm:text-5xl md:text-7xl tracking-tighter leading-[1.02] text-[#2C241E] max-w-4xl"
              >
                Notes From the Treatment Room.
              </h1>
              <p className="mt-6 text-base md:text-lg leading-relaxed text-[#2C241E]/70 max-w-2xl">
                Recovery tips, movement culture, and behind-the-brand notes — written by the
                founder, not a content team.
              </p>
            </Reveal>
            <div className="mt-16 space-y-4">
              {ARTICLES.map((a, i) => (
                <Reveal key={a.id} delay={i * 0.08}>
                  <button
                    data-testid={`journal-article-${a.id}`}
                    onClick={() => setOpen(a.id)}
                    className="group w-full text-left rounded-2xl border border-[#2C241E]/10 bg-[#F3F1EB] p-7 md:p-10 transition-[transform,box-shadow] duration-300 hover:-translate-y-0.5 hover:shadow-lg"
                  >
                    <div className="flex items-center justify-between gap-6">
                      <div>
                        <p className="text-[10px] font-medium tracking-[0.2em] uppercase text-[#A07856] mb-3">
                          {a.category} · {a.date}
                        </p>
                        <h2 className="font-display text-2xl md:text-4xl tracking-tight text-[#2C241E]">
                          {a.title}
                        </h2>
                        <p className="mt-3 text-sm md:text-base leading-relaxed text-[#2C241E]/60 max-w-2xl">
                          {a.excerpt}
                        </p>
                      </div>
                      <ArrowUpRight
                        size={22}
                        strokeWidth={1.5}
                        className="shrink-0 text-[#2C241E]/40 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
                      />
                    </div>
                  </button>
                </Reveal>
              ))}
            </div>
          </>
        ) : (
          <article data-testid="journal-article-view" className="max-w-3xl mx-auto">
            <button
              data-testid="journal-back-button"
              onClick={() => setOpen(null)}
              className="inline-flex items-center gap-2 text-xs font-medium tracking-[0.2em] uppercase text-[#2C241E]/60 transition-colors duration-200 hover:text-[#2C241E] mb-10"
            >
              <ArrowLeft size={16} strokeWidth={1.75} />
              All notes
            </button>
            <p className="text-[10px] font-medium tracking-[0.2em] uppercase text-[#A07856] mb-4">
              {article.category} · {article.date}
            </p>
            <h1 className="font-display text-4xl md:text-6xl tracking-tighter leading-[1.05] text-[#2C241E]">
              {article.title}
            </h1>
            <div className="mt-10 space-y-6">
              {article.body.map((p, i) => (
                <p key={i} className="text-base md:text-lg leading-relaxed text-[#2C241E]/75">
                  {p}
                </p>
              ))}
            </div>
            <p className="mt-12 text-xs font-medium tracking-[0.2em] uppercase text-[#2C241E]/40">
              Dr Shivam Jhatta PT — Founder
            </p>
          </article>
        )}
      </section>
    </main>
  );
}
